import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyEmptyStateModule } from '@vendasta/galaxy/empty-state';
import { GalaxyStickyFooterModule } from '@vendasta/galaxy/sticky-footer';
import { BaseCrmModelDrivenFormComponent } from './base-model-driven-form.component';
import { CrmFormButtonGroupComponent } from './form-button-group.component';
import { CrmFormLoadingIndicatorComponent } from './form-loading-indicator.component';
import { RendererSelectorComponent } from '../../renderer-selector.component';
import { VerticalNavTabComponent } from '../../../vertical-nav-tab';
import { VerticalNavCardComponent } from '../../../vertical-nav-tab';

@Component({
  selector: 'crm-card-group-driven-form',
  templateUrl: './card-group-driven-form.component.html',
  styleUrls: ['./base-model-driven-form.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatIconModule,
    ReactiveFormsModule,
    TranslateModule,
    GalaxyEmptyStateModule,
    GalaxyStickyFooterModule,
    CrmFormButtonGroupComponent,
    CrmFormLoadingIndicatorComponent,
    RendererSelectorComponent,
    VerticalNavTabComponent,
    VerticalNavCardComponent,
  ],
  encapsulation: ViewEncapsulation.None,
})
export class CrmCardGroupDrivenFormComponent extends BaseCrmModelDrivenFormComponent {}
